module.exports = __webpack_public_path__ + "img/defense.ad94419f.svg";